var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_665_1417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_665_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.226 17.6827L10.3221 14.7788C10.1491 14.6058 9.93152 14.5172 9.6695 14.5132C9.40748 14.5092 9.18593 14.5977 9.00484 14.7788C8.82376 14.9599 8.73322 15.1795 8.73322 15.4375C8.73322 15.6955 8.82376 15.915 9.00484 16.0961L12.4351 19.5264C12.6611 19.7523 12.9247 19.8653 13.226 19.8653C13.5273 19.8653 13.7909 19.7523 14.0168 19.5264L20.9712 12.5721C21.1442 12.399 21.2328 12.1815 21.2368 11.9194C21.2408 11.6574 21.1523 11.4359 20.9712 11.2548C20.7901 11.0737 20.5705 10.9832 20.3125 10.9832C20.0545 10.9832 19.835 11.0737 19.6539 11.2548L13.226 17.6827ZM15.0021 26.8749C13.3597 26.8749 11.8159 26.5633 10.3707 25.9399C8.92556 25.3166 7.66846 24.4707 6.59944 23.4021C5.53039 22.3336 4.68407 21.077 4.06047 19.6325C3.43686 18.188 3.12506 16.6445 3.12506 15.0021C3.12506 13.3596 3.43673 11.8159 4.06006 10.3707C4.68339 8.9255 5.52933 7.6684 6.59787 6.59938C7.66644 5.53033 8.92299 4.68401 10.3675 4.06041C11.8121 3.4368 13.3555 3.125 14.9979 3.125C16.6404 3.125 18.1841 3.43667 19.6293 4.06C21.0745 4.68333 22.3316 5.52927 23.4006 6.59781C24.4697 7.66638 25.316 8.92293 25.9396 10.3675C26.5632 11.812 26.875 13.3555 26.875 14.9979C26.875 16.6403 26.5633 18.1841 25.94 19.6293C25.3167 21.0744 24.4707 22.3315 23.4022 23.4006C22.3336 24.4696 21.0771 25.3159 19.6325 25.9395C18.188 26.5631 16.6445 26.8749 15.0021 26.8749Z",
    fill: "#DFE3E6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxIcon);
export default __webpack_public_path__ + "static/media/checkBoxIcon.303a2f2c8d44a5315d71f8865985ae50.svg";
export { ForwardRef as ReactComponent };